import { render, staticRenderFns } from "./prod_type51.vue?vue&type=template&id=45af8876&scoped=true"
import script from "./prod_type51.vue?vue&type=script&lang=js"
export * from "./prod_type51.vue?vue&type=script&lang=js"
import style0 from "./prod_type51.vue?vue&type=style&index=0&id=45af8876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af8876",
  null
  
)

export default component.exports